


















import { Component } from 'vue-property-decorator';
import CampaignBrowseOpportunities from '@/components/CampaignOpportunities/CampaignBrowseOpportunities.vue';
import CampaignOpportunities from '@/components/CampaignOpportunities/CampaignOpportunities.vue';
import { CampaignDetailsModule } from '@/store/modules/campaignDetails';
import GiganautVue from '@/components/Shared/GiganautVue';

@Component({
  name: 'CampaignOpportunitiesTab',
  components: { CampaignBrowseOpportunities, CampaignOpportunities }
})
export default class extends GiganautVue {

    currentTabIndex = -1;

    async beforeMount() {
        await CampaignDetailsModule.getCampaignOpportunities();
        await CampaignDetailsModule.browseOpportunities();
        if (this.campaignOpportunities.length > 0) {
            this.currentTabIndex = 1;
        }
    }

    get loading() {
        return CampaignDetailsModule.loadingOpportunities;
    }

    get campaignOpportunities() {
        return CampaignDetailsModule.campaignOpportunitiesVM.campaignOpportunities;
    }
}
